/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

// Reuse the summary-table cell primitives (same visual tokens, fewer columns).
export {
  HeaderCell,
  HeaderText,
  HeaderSubText,
  ForecastHeaderCell,
  DataCell,
  ValueText,
} from '../KpiSection/KpiTable/styles';

// Narrow bordered box (Figma 10286:128462): 3-col Расход mini-table + CTA hatch below.
// Left-aligned, content-width (not full card width).
export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'flex-start',
  width: 'fit-content',
  maxWidth: '100%',
  border: `1px solid ${theme.palette.semantic_dark?.surface.surface2}`,
  borderRadius: 8,
  overflow: 'hidden',
}));

// Grid: Показатель | Факт на сегодня | (Прогноз). Column count is dynamic — the «Прогноз»
// column is dropped under the <7-days-of-fact rule (see NoMediaplanSummary showForecast).
export const Grid = styled(Box, {
  shouldForwardProp: prop => prop !== 'columns',
})<{columns: number}>(({columns}) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${columns}, auto)`,
  width: '100%',
}));

// Row separator spanning all grid columns (header ↔ Расход row).
export const RowDivider = styled(Box, {
  shouldForwardProp: prop => prop !== 'columns',
})<{columns: number}>(({theme, columns}) => ({
  gridColumn: `1 / span ${columns}`,
  height: 0,
  borderTop: `1px solid ${theme.palette.semantic_dark?.surface.surface2}`,
}));

// Full-box divider between the mini-table and the CTA hatch.
export const FullDivider = styled(Box)(({theme}) => ({
  width: '100%',
  height: 0,
  borderTop: `1px solid ${theme.palette.semantic_dark?.surface.surface2}`,
}));
